var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 798,
    height: 209,
    viewBox: "0 0 798.205 208.899",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 96",
    x: 134.478,
    y: 14.8936,
    width: 72.8642,
    height: 9.87122,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 115",
    x: 543.262,
    y: 14.8936,
    width: 69.4467,
    height: 9.87122,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 133",
    x: 409.281,
    y: 15.1761,
    width: 69.4467,
    height: 9.87122,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 139",
    x: 679.117,
    y: 14.8912,
    width: 100.846,
    height: 9.87122,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 94",
    x: 225.254,
    y: 14.8936,
    width: 22.194,
    height: 83.0751,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M317.408 0C318.77 0 319.874 1.10388 319.874 2.46582V49.1094L345.16 23.8057L345.341 23.6416C345.78 23.2818 346.332 23.0831 346.904 23.083C347.559 23.083 348.186 23.343 348.648 23.8057L359.574 34.7393C360.536 35.7021 360.536 37.2627 359.574 38.2256L331.527 66.292L515.222 71.625C516.556 71.6637 517.617 72.7564 517.616 74.0908C517.616 75.4252 516.554 76.5169 515.22 76.5547L330.341 81.7891L358.282 109.752C359.244 110.715 359.244 112.275 358.282 113.238L347.356 124.171C346.894 124.634 346.267 124.894 345.612 124.894C344.958 124.893 344.331 124.634 343.868 124.171L319.874 100.158V148.589C319.874 149.951 318.77 151.055 317.408 151.055H301.44C300.079 151.055 298.975 149.951 298.975 148.589V98.8691L273.688 124.174C273.226 124.636 272.599 124.896 271.944 124.896C271.29 124.896 270.663 124.637 270.2 124.174L259.274 113.241C258.312 112.278 258.312 110.718 259.274 109.755L285.963 83.0459L239.026 84.377C238.361 84.3958 237.715 84.1448 237.237 83.6807C236.76 83.2164 236.49 82.5782 236.49 81.9121V66.0742C236.49 65.408 236.76 64.77 237.237 64.3057C237.715 63.8414 238.361 63.5902 239.027 63.6094L284.674 64.9326L257.985 38.2256C257.023 37.2628 257.023 35.7021 257.985 34.7393L268.91 23.8057L269.091 23.6416C269.53 23.2819 270.082 23.0831 270.654 23.083C271.309 23.083 271.936 23.343 272.398 23.8057L298.975 50.3994V2.46582C298.975 1.10397 300.079 0.000131913 301.44 0H317.408Z",
    fill: "url(#paint0_linear_0_4)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 84",
    x: 87.4669,
    y: 15.4484,
    width: 24.6483,
    height: 177.856,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 101",
    x: 363.054,
    y: 14.8936,
    width: 24.6483,
    height: 178.41,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 85",
    x: 104.105,
    y: 43.1674,
    width: 20.5417,
    height: 12.339,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 129",
    x: 239.437,
    y: 43.3293,
    width: 20.5417,
    height: 12.339,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 102",
    x: 275.688,
    y: 164.254,
    width: 112.015,
    height: 12.339,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 97",
    x: 134.478,
    y: 51.6988,
    width: 75.2011,
    height: 9.87122,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 98",
    x: 134.478,
    y: 88.099,
    width: 75.2011,
    height: 9.87122,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 99",
    x: 134.478,
    y: 51.6988,
    width: 24.66,
    height: 46.2713,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 100",
    x: 185.019,
    y: 14.8936,
    width: 24.66,
    height: 36.8038,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    d: "M200.996 106.277C224.028 106.278 241.518 129.989 241.519 157.589C241.518 185.188 224.028 208.899 200.996 208.899C177.964 208.899 160.473 185.189 160.473 157.589C160.473 129.989 177.964 106.277 200.996 106.277ZM201.251 122.223C197.442 122.223 193.279 125.219 189.895 131.666C186.582 137.975 184.444 146.895 184.444 156.91C184.444 166.925 186.582 175.846 189.895 182.154C193.28 188.601 197.442 191.597 201.251 191.598C205.06 191.597 209.223 188.601 212.607 182.154C215.92 175.846 218.058 166.925 218.058 156.91C218.058 146.895 215.92 137.975 212.607 131.666C209.223 125.219 205.06 122.223 201.251 122.223Z",
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    d: "M40.7998 55.0371C43.6416 56.6593 46.3154 59.0476 48.7842 62.042C53.6323 67.9227 57.8984 76.355 61.4336 86.707C64.9789 97.089 67.7706 109.35 69.6699 122.777C71.5708 136.216 72.5469 151.27 72.5469 165.773V168.732H48.9102L49.002 165.685C49.1085 162.154 49.1641 158.553 49.1641 154.896C49.1641 131.84 46.734 113.893 43.3301 101.647C41.6243 95.5113 39.7074 90.9288 37.8115 87.874C37.2065 86.8992 36.6394 86.1397 36.124 85.5498L23.5049 167.907H0L23.4336 14.9756H46.9385L40.7998 55.0371Z",
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 107",
    x: 496.648,
    y: 14.8936,
    width: 24.6483,
    height: 178.41,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 113",
    x: 630.643,
    y: 14.8936,
    width: 24.6483,
    height: 178.894,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 108",
    x: 513.286,
    y: 43.247,
    width: 20.5417,
    height: 12.339,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 114",
    x: 647.24,
    y: 43.247,
    width: 20.5417,
    height: 12.339,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    d: "M741.87 112.303H779.888V124.642H679.092V112.303H717.21V92.5596H741.87V112.303Z",
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 110",
    x: 409.281,
    y: 155.903,
    width: 74.2209,
    height: 9.87122,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 116",
    x: 543.262,
    y: 155.903,
    width: 71.8835,
    height: 9.87122,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 119",
    x: 543.262,
    y: 85.3975,
    width: 71.8835,
    height: 9.87122,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 138",
    x: 679.092,
    y: 75.5265,
    width: 100.846,
    height: 9.87122,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 140",
    x: 679.117,
    y: 45.2088,
    width: 100.846,
    height: 9.87122,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 90",
    x: 679.092,
    y: 180.965,
    width: 100.871,
    height: 12.339,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 89",
    x: 679.092,
    y: 20.1696,
    width: 24.66,
    height: 65.2281,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 111",
    x: 409.281,
    y: 20.1117,
    width: 24.66,
    height: 145.661,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 117",
    x: 543.262,
    y: 85.3975,
    width: 24.66,
    height: 80.376,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 112",
    x: 458.842,
    y: 15.4603,
    width: 24.66,
    height: 144.468,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 118",
    x: 592.822,
    y: 14.8936,
    width: 24.66,
    height: 80.3748,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 91",
    x: 679.092,
    y: 131.859,
    width: 24.66,
    height: 51.8239,
    fill: "#5170FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclude_2",
    d: "M672.678 81.7783C673.532 81.7783 674.224 82.4703 674.224 83.3242V112.569L690.078 96.7041L690.191 96.6016C690.467 96.3758 690.813 96.251 691.172 96.251C691.582 96.251 691.976 96.4139 692.266 96.7041L699.115 103.559C699.718 104.162 699.718 105.14 699.115 105.744L681.53 123.341L796.704 126.686C797.54 126.71 798.205 127.396 798.205 128.232C798.204 129.069 797.539 129.754 796.703 129.777L680.79 133.06L698.307 150.589C698.91 151.193 698.91 152.171 698.307 152.774L691.457 159.629C691.167 159.919 690.773 160.082 690.363 160.082C689.953 160.082 689.56 159.919 689.27 159.629L674.224 144.571V174.939C674.224 175.793 673.532 176.485 672.678 176.485H662.667C661.813 176.485 661.121 175.793 661.121 174.939V143.765L645.267 159.632C644.977 159.922 644.583 160.085 644.173 160.085C643.763 160.085 643.369 159.922 643.079 159.632L636.229 152.776C635.626 152.173 635.626 151.195 636.229 150.591L652.961 133.847L623.536 134.682C623.119 134.693 622.714 134.535 622.414 134.244C622.115 133.953 621.946 133.553 621.946 133.136V123.205C621.946 122.787 622.115 122.387 622.415 122.096C622.715 121.805 623.12 121.647 623.537 121.659L652.157 122.488L635.423 105.743C634.82 105.14 634.82 104.161 635.423 103.558L642.272 96.7031L642.386 96.6006C642.661 96.3748 643.007 96.25 643.366 96.25C643.776 96.25 644.17 96.4129 644.46 96.7031L661.121 113.376V83.3242C661.121 82.4703 661.813 81.7783 662.667 81.7783H672.678Z",
    fill: "url(#paint1_linear_0_4)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 286.879,
    y1: 70.7586,
    x2: 429.649,
    y2: 86.5098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_4",
    x1: 653.539,
    y1: 126.142,
    x2: 743.051,
    y2: 136.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroLogo);
export default __webpack_public_path__ + "static/media/hero-logo.d4df3da9d63c55f90a1bfdcfca926509.svg";
export { ForwardRef as ReactComponent };